import { render } from "./dpEdit.vue?vue&type=template&id=56d4bfbf"
import script from "./dpEdit.vue?vue&type=script&lang=js"
export * from "./dpEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__